<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import Modal from "./Modal.svelte";
  import OfferCard from "./OfferCard.svelte";
  import OffersFilter from "./OffersFilter.svelte";
  import OfferCardModal from "./OfferCardModal.svelte";
  export let request_store_key: StoresKey;
  const { offers } = getStoresContext(request_store_key);
  let filter_offers: Array<ManageAPI.Offer>;
  let search_value: string = "";

  $: {
    if (search_value) {
      const term = search_value.toLowerCase();
      filter_offers = $offers.filter(
        (offer) => offer.store && offer.store.name.toLowerCase().includes(term)
      );
    } else {
      filter_offers = [...$offers];
    }
  }
  function search(event: CustomEvent) {
    search_value = event.detail;
  }
  function focusOffer(event: CustomEvent) {
    id = event.detail;
  }
  let focusedOffer: ManageAPI.Offer;
  $: if (id != 0) {
    focusedOffer = $offers.find((offer) => offer.id === id)!;
  }

  let id = 0;
</script>

<OffersFilter on:search={search} {request_store_key} />
{#if filter_offers.length}
  <div class="row">
    {#each filter_offers as offer}
      <div class="col-md-4 col-sm-6 col-12 mb-5">
        <OfferCard {offer} on:focusOffer={focusOffer} {request_store_key} />
      </div>
    {/each}
  </div>
{/if}

<Modal bind:id {request_store_key}>
  {#if id}
    <OfferCardModal {request_store_key} offer={focusedOffer} />
  {/if}
</Modal>
